import React from 'react';
import InformationIcon from "./information.png";

export const ToolTipElement = ({ setShowModal, setType, type, clickHandler }) => {
    return (
      <div
        style={{ height: "20px", width: "20px" }}
        onClick={() =>  {
            if(clickHandler) clickHandler() ;
            if(!clickHandler) {
                setType(type)
                setShowModal(true)
            }
        }}>
        <img height='15px' width='15px' src={InformationIcon} alt="" />
      </div>
    );
  };


// WEBPACK FOOTER //
// ./src/Pages/Stock/ToolTipElement.jsx